import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FloatingPillComponent } from './floating-pill.component';

// PERF: FloatingPillComponent is the only part of OrderCreateModule the eager app
// shell needs (the persistent "new order" button in app.component.html). Extracting
// it into this tiny eager module lets the heavy OrderCreateModule (~9k LOC + keen-slider)
// drop out of the eager graph and load only via its lazy `/order/...` route.
@NgModule({
    declarations: [FloatingPillComponent],
    exports: [FloatingPillComponent],
    imports: [CommonModule, SharedModule],
})
export class FloatingPillModule {}
